<template>
    <div>
        <Row :gutter="10" type="flex" justify="start">
        <Col :span="6">
            <RadioGroup v-model="searchForm.timeType" type="button" button-style="solid" style="width: 100%;display:flex;padding:0">
                <Radio label="day" style="width: calc(100% / 3);text-align: center;">日报</Radio>
                <Radio label="week" style="width: calc(100% / 3);text-align: center;">周报</Radio>
                <Radio label="month" style="width: calc(100% / 3);text-align: center;">月报</Radio>
            </RadioGroup>
        </Col>
        <Col :span="6">
            <DatePicker :editable="false" transfer format="yyyy-MM-dd" type="daterange" style="width: 100%;" :options="options"
                placeholder="请选择日期" :value="listDate" @on-change="getListDate" :clearable="false"></DatePicker>
        </Col>
        <Col :span="3">
            <Select transfer placeholder="推广渠道" clearable v-model="searchForm.channel">
                <Option :value="-2">全部渠道</Option>
                <Option :value="0">facebook</Option>
                <Option :value="1">tiktok</Option>
                <Option :value="2">google</Option>
            </Select>
            </Col>
        <Col :span="3">
            <Select transfer  v-model="searchForm.personIds"
                placeholder="请选择优化师" filterable :max-tag-count="1" multiple>
                <Option v-for="(i, index) in searchOptions.person" :key="index" :value="i.id">{{ i.dictName }}
                </Option>
            </Select>
        </Col>
        <Col :span="3">
            <Select transfer  v-model="searchForm.timezoneOffset"
                placeholder="时区偏移量">
                <Option :value="-8" label="美国时间">美国时间(西八区 UTC-8)</Option>
                    <Option :value="0" label="世界标准时间">世界标准时间(UTC+0)</Option>
                <Option :value="8" label="北京时间">北京时间(东八区 UTC+8)</Option>
            </Select>
        </Col>
        <Col :span="1">
        
            <Button type="primary" @click="handleSearchData">搜索</Button>
        </Col>

        <div style="flex-grow: 1;text-align: right;padding-right: 12px;padding: 0 5px">
                <Tooltip transfer content="点击下载">
                    <Button style="padding:4px 5px" :loading="exportLoading"
                        @click="handleExport">
                        <Icon type="md-download" :size="20" />
                    </Button>
                </Tooltip>
                <Tooltip transfer content="自定义列">
                    <Button style="margin-left: 10px;padding:4px 5px" @click="visible = true">
                        <Icon type="md-options" :size="20" />
                    </Button>
                </Tooltip>
                
            </div>
        </Row>
        <div style="display: flex;flex-wrap: wrap;">
            
            <!-- <Button style="margin: 10px 10px 0 0" @click="handleReset">重置</Button> -->
            <div style="flex-grow: 1;text-align: right;margin-top: 10px;">
                
                    <Modal v-model="visible" :width="1000" title="自定义字段编辑" footer-hide>
            <fieldSelector  v-model="column" :orgin="flagColumn" @upload:visible="visible=false" @upload:column="submitColumn"  />

        </Modal>
            </div>
        </div>
        <Table ref="tableRef" style="margin-top: 20px;" :search-form="{
            ...searchForm,
            channel: searchForm.channel == -2?null:searchForm.channel
        }" :column="columns" :func="getPitcherData" />
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { getPlayList } from '@/api/play'
import { debounce } from 'lodash'
import { getPitcherData, exportPitcher } from '@/api/data'
import { columnData } from '../index'
import draggable from 'vuedraggable';
import Table from '../Table.vue';
import fieldSelector from '../../../../../components/fieldSelector/index.vue'
export default {
    components: {
        draggable,
        Table,
        fieldSelector
    },
    props: {
        searchOptions: {
            type: Object,
            default: () => ({
                person: []
            })
        },
        flag: {
            type:Number|String,
            default: 1
        }
    },
    inject: ['parent'],
    data() {
        return {
            options: {
                    shortcuts: [
                        {
                            text: '今日',
                            value () {
                                return [dayjs().add(-16, 'hour').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近三天',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-2,'day').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近七天',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-6,'day').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近一个月',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-1,'month').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        }
                    ],},
            keyword: '',
            visible: false,
            searchForm: {
                timeType: 'day',
                channel: -2,
                personIds: [],
                timezoneOffset: -8
            },
            exportLoading: false,
            getPitcherData,
            flagColumn: [],
            newColumn: [],
            columnData,
            column: [],
            columns: [],
            tempColumn: [],
            playLoading: false,
            listDate: [],
            playList: []
        }
    },
    watch: {
        flag(){
            const li = [...this.column]
            this.column = []
            this.column = li.map(i=>{
                const obj = columnData.find(j=>j.key == i)||{}
                if(obj.flag&&this.flag == 1){
                    return i.replaceAll('All','New')
                }else if (obj.flag&&this.flag==2) {
                    return i.replaceAll('New','All')
                    
                }
                return i
            })
            this.flagColumn = this.newColumn.filter(i=>!i.flag||i.flag==this.flag)
            this.submitColumn()
        },
        visible(){
            this.column = this.columns.map(i=>i.key)
        }
    },
    methods: {
        dragStart() {
            this.tempColumn = [...this.column]
        },
        handleSearchData(){
            this.$refs.tableRef.handleGetData()
        },
        dragEnd(row) {
            const indexli = this.columnData.filter(i => i.always).map((i, index) => index)
            if (indexli.includes(row.newIndex) || indexli.includes(row.oldIndex)) this.column = [...this.tempColumn]
        },
        submitColumn() {
            this.columns = this.column
                .map(i => {
                    const obj = this.newColumn.find(j => j.key == i)
                    return obj ? {
                        title: obj.title,
                        key: obj.key,
                        index: obj.index,
                        fixed: obj.fixed,
                        unit: obj.unit,
                        width: obj.width ? obj.width : (obj.title.length > 5 ? 140 : 100),
                        needCalc: obj.needCalc,
                        tooltip: !!obj.tooltip,
                        notFixed: obj.notFixed,
                        tooltipMaxWidth: obj.tooltipMaxWidth,
                        slot: obj.slot,
                        resizable: true,
                        calc: obj.calc,
                        sortable: !obj.sortable ? false : 'custom',
                        render: obj.render
                    } : null
                })
                .filter(Boolean)
            this.visible = false
            localStorage.setItem('user-column', JSON.stringify(this.columns))
            localStorage.setItem('user-campaign-flag', this.flag)
        },
        handleGetPlay: debounce(function (query) {
            if (!query) {
                this.playList = []
                this.playLoading = false
            } else {
                this.playLoading = true
                getPlayList({
                    current: -1,
                    playName: query,
                    size: -1
                }).then(r => {
                    this.playList = r.data.records
                    this.playLoading = false
                })
            }
        }, 700),
        getListDate(data) {
            this.listDate = data
            this.searchForm.startDate = data[0]
            this.searchForm.endDate = data[1]
            this.parent.searchDate = data
        },
        handleReset() {
            this.searchForm={
                personIds:[],
                channel: -2,
                timezoneOffset: -8,
                timeType: 'day'
            }
            this.getListDate([dayjs().add(-16, 'hour').format('YYYY-MM-DD'), dayjs().add(-16, 'hour').format('YYYY-MM-DD')])
            
        },
        handleSelectAll() {
            this.column = [...this.column, ...this.flagColumn.filter(i => !this.column.includes(i.key)).map(i => i.key)]
        },
        handleResetColumn() {
            this.column = this.flagColumn.filter(i => i.always).map(i => i.key)
        },
        handleExport() {
            this.exportLoading = true
            exportPitcher({
                ...this.searchForm,
                channel: this.searchForm.channel == -2?null:this.searchForm.channel
            }).then(r=>{
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = r.data.fileUrl
                // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
                link.setAttribute('download', r.data.fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.exportLoading = false
            }).catch(e=>{
                this.exportLoading = false
            })
        },
    },
    mounted() {
        
        this.columnData.find(i=>i.key=='person').render = (h,params)=>{
            return <div style={{cursor:'pointer',color: '#2d8cf0'}} onClick={()=>{
                this.parent.extraData = {}
                this.parent.tabIndex = '1'
                this.parent.extraData = {
                    personIds: [params.row.personId]
                }
                
            }}>
                {params.row.person}
                </div>
        }
        this.newColumn = this.columnData.filter(i=>!i.only||i.only.includes('pitcher'))
        this.newColumn[1].always = true
        this.newColumn[1].fixed = 'left'
        this.flagColumn = this.newColumn.filter(i=>!i.flag||i.flag==this.flag)
        try {
            const column = localStorage.getItem('user-column')
            if (column) {
                this.column = JSON.parse(column).map(i => i.key)
            } else {
                this.column = [...this.flagColumn].map(i=>i.key)
            }
        } catch (e) {
            // 处理JSON解析错误或无效数据
            this.column = [...this.flagColumn].map(i=>i.key)
        }
        
        const date = this.parent.searchDate
        this.handleReset()
        
        if (date && date.length) {
            // this.searchForm.startDate = JSON.parse(date)[0]
            // this.searchForm.endDate = JSON.parse(date)[1]
            this.getListDate([date[0], date[1]])
        }
        this.submitColumn()
        this.$nextTick(()=>{
            this.handleSearchData()
            const scroll = document.querySelector(".ivu-table-body");
                const fixed = document.querySelector(".ivu-table-fixed-body");
                
                // 监听滚轮
                scroll &&
                    scroll.addEventListener(
                    "mousewheel",
                    (e) => {
                        if (scroll.scrollLeft <= 0 && e.deltaX < 0) {
                            e.preventDefault();
                        }
                    },
                    {
                        passive: false,
                    }
                    );
                fixed &&
                    fixed.addEventListener("wheel", (e) => {
        if(e.deltaX)e.preventDefault();

                    e.preventDefault();
                    });
        })
    },
    activated(){
        const date = this.parent.searchDate
        const li = [...this.column]
            this.column = []
            this.column = li.map(i=>{
                const obj = columnData.find(j=>j.key == i)||{}
                if(obj.flag&&this.flag == 1){
                    return i.replaceAll('All','New')
                }else if (obj.flag&&this.flag==2) {
                    return i.replaceAll('New','All')
                    
                }
                return i
            })
            this.flagColumn = this.newColumn.filter(i=>!i.flag||i.flag==this.flag)
            this.submitColumn()
        if (date && date.length) {
            // this.searchForm.startDate = JSON.parse(date)[0]
            // this.searchForm.endDate = JSON.parse(date)[1]
            this.getListDate([date[0], date[1]])
        }
    }
}
</script>

<style lang="less" scoped>
.checkbox {
    margin: 0 -10px;
    overflow: hidden;
    width: 100%;
    &>* {
        width: 50%;
        flex: 0 50%;
        padding: 5px 10px;
        font-size: 16px;
    }
}
/deep/.ivu-checkbox{
    margin-right: 10px;
}
</style>